import React, { useState, useEffect } from "react";

const ExceptionalHoursListModal = ({
  isOpen,
  onClose,
  exceptionalHours,
  onUpdate,
  onDelete,
}) => {
  const [editedHours, setEditedHours] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    if (isOpen) {
      setEditedHours(exceptionalHours || []); // Set exceptional hours when modal opens
    }
  }, [exceptionalHours, isOpen]);

  const handleEditChange = (index, field, value) => {
    const updatedHours = [...editedHours];
    if (field === "delete") {
      const hourToDelete = updatedHours[index];
      onDelete(hourToDelete._id); // Call the delete function with the hour ID
      updatedHours.splice(index, 1); // Remove hour from the local state
    } else {
      updatedHours[index][field] = value; // Edit hour
    }
    setEditedHours(updatedHours);
  };

  const handleSave = () => {
    onUpdate(editedHours); // Call the update function with the edited hours
    onClose(); // Close the modal
  };

  // Filtered hours based on search query and date range
  const filteredHours = editedHours.filter((hour) => {
    const hourDate = new Date(hour.data); // Assuming `data` is in date format
    const dateMatches =
      hourDate >= new Date(startDate) && hourDate <= new Date(endDate);
    const textMatches =
      hour.data.includes(searchQuery) ||
      hour.godzina_start.includes(searchQuery) ||
      hour.godzina_koniec.includes(searchQuery);
    return startDate === "" && endDate === ""
      ? textMatches
      : dateMatches && textMatches;
  });

  if (!isOpen) return null; // Don't render anything if the modal is not open

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={onClose}
      ></div>
      <div className="bg-white rounded-lg shadow-lg p-8 z-10 w-[480px] max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6">Wyjątkowe Godziny</h2>

        {/* Search Input */}
        <input
          type="text"
          placeholder="Szukaj..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="border border-gray-300 rounded-md p-2 w-full mb-4"
        />

        {/* Date Range Inputs */}
        <div className="flex space-x-2 mb-4">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="border border-gray-300 rounded-md p-2 w-full"
          />
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="border border-gray-300 rounded-md p-2 w-full"
          />
        </div>

        <table className="w-full">
          <thead>
            <tr>
              <th>Data</th>
              <th>Godzina Start</th>
              <th>Godzina Koniec</th>
              <th>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {filteredHours.length > 0 ? (
              filteredHours.map((hour, index) => (
                <tr key={hour._id}>
                  {" "}
                  {/* Use hour._id as the key */}
                  <td>
                    <input
                      type="date"
                      value={hour.data.split("T")[0]} // Format the date
                      onChange={(e) =>
                        handleEditChange(index, "data", e.target.value)
                      }
                      className="border border-gray-300 rounded-md p-2 w-full mb-2"
                    />
                  </td>
                  <td>
                    <input
                      type="time"
                      value={hour.godzina_start}
                      onChange={(e) =>
                        handleEditChange(index, "godzina_start", e.target.value)
                      }
                      className="border border-gray-300 rounded-md p-2 w-full mb-2"
                    />
                  </td>
                  <td>
                    <input
                      type="time"
                      value={hour.godzina_koniec}
                      onChange={(e) =>
                        handleEditChange(
                          index,
                          "godzina_koniec",
                          e.target.value
                        )
                      }
                      className="border border-gray-300 rounded-md p-2 w-full mb-2"
                    />
                  </td>
                  <td>
                    <button
                      onClick={() => handleEditChange(index, "delete")}
                      className="px-2 py-1 text-red-500"
                    >
                      Usuń
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  Brak wyników
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={handleSave}
            className="px-4 py-2 rounded-md text-white bg-blue-500 hover:bg-blue-600 transition-colors duration-200"
          >
            Zapisz
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
          >
            Zamknij
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExceptionalHoursListModal;
